module.exports = __webpack_public_path__ + "img/picpay.a8c2a69b.png";